<script>
    import router from "page";
    import { onMount } from "svelte";
    import { isLoading, locale } from "../stores.js";

    import Checkbox from "../components/Checkbox.svelte";
    import Datepicker from "../components/Datepicker.svelte";

    import { TabulatorFull as Tabulator } from "tabulator-tables";

    import { getLocaleResource } from "../utils/locales.js";

    import {
        fetchGet,
        fetchPost,
        fetchPatch,
        fetchDelete,
    } from "../utils/utilsFetch.js";

    import {
        productPictureLinkFormatter,
        numberFormatter,
        oneDecimalFormatter,
        percentFormatter,
        dateFormatter,
        keywordFilter,
    } from "../utils/utilsTabulator.js";

    let table,
        imports = [],
        tableElement;

    onMount(async () => {
        $isLoading = true;

        imports = await fetchGet(`/api/imports`);

        table = new Tabulator(tableElement, {
            height: "100%",
            data: imports,
            layout: "fitDataFill",
            vertAlign: "middle",
            columnCalcs: "both",
            columns: [
                {
                    title: getLocaleResource($locale, "date"),
                    field: "orderDate",
                    formatter: dateFormatter,
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: getLocaleResource($locale, "client"),
                    field: "companyKey",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: getLocaleResource($locale, "sku"),
                    field: "sku",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: getLocaleResource($locale, "reservation"),
                    field: "isReservationText",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: getLocaleResource($locale, "product"),
                    field: "productName",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: getLocaleResource($locale, "quantity"),
                    field: "quantity",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: getLocaleResource($locale, "note"),
                    field: "note",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: getLocaleResource($locale, "import"),
                    field: "isImported",
                    formatter: checkBoxColumn,
                },
            ],
        });

        $isLoading = false;
    });

    // https://svelte.dev/repl/d50ff917f6cc41b5964a465226c1c4b2?version=3.44.1

    function checkBoxColumn(cell, formatterParams, onRendered) {
        // Need to wait for the cell to be rendered so cell dom and it's data exist.
        onRendered(() => {
            // Render Svelte component into Tabulator's cell.
            // stopButton,logsButton variables are never used.
            let data = cell._cell.row.data;
            new Checkbox({
                target: cell.getElement(),
                props: {
                    props: { id: data.id },
                    value: data.isImported,
                    callback: updateCartItemImportStatus,
                },
            });
        });
    }

    async function updateCartItemImportStatus(value, props) {
        await fetchPatch(`/api/imports/items/${props.id}`, {
            isImportedBool: value,
        });
    }

    async function downloadExcel() {
        let now = new Date();
        let timestamp = `${
            now.toISOString().split("T")[0]
        } ${now.toLocaleTimeString("en-GB")}`; // 2020-04-18 14_03_05
        table.download("xlsx", `Uvoz - ${timestamp}.xlsx`);
    }

    let filterFromDate, filterToDate;

    $: filter(filterFromDate, filterToDate);

    function filter(from, to) {
        if (!table || !imports) return;

        let filteredImports = imports;

        if (from && !to) {
            filteredImports = imports.filter(
                (item) => new Date(from) <= new Date(item.orderDate)
            );
        }

        if (!from && to) {
            filteredImports = imports.filter(
                (item) => new Date(item.orderDate) <= new Date(to)
            );
        }

        if (from && to) {
            filteredImports = imports.filter(
                (item) =>
                    new Date(from) <= new Date(item.orderDate) &&
                    new Date(item.orderDate) <= new Date(to)
            );
        }

        table.replaceData(filteredImports);
    }
</script>

<svelte:head>
    <script
        type="text/javascript"
        src="https://oss.sheetjs.com/sheetjs/xlsx.full.min.js"
    >
    </script>
</svelte:head>

<div class="container">
    <div class="header">
        <button class="btn btn-green" on:click={downloadExcel}>
            <i class="fas fa-file-excel" />
            <span> Excel </span>
        </button>

        <Datepicker
            bind:value={filterFromDate}
            save={() => {}}
            placeholder={"Od..."}
            style="width: 200px;"
        />

        <Datepicker
            bind:value={filterToDate}
            save={() => {}}
            placeholder={"Do..."}
            style="width: 200px;"
        />
    </div>

    <div class="content">
        <div class="table" bind:this={tableElement} />
    </div>
</div>

<style>
    .container {
        display: grid;
        grid-template-columns: 1fr;
        /* calc sprecuva tabelata da ide nadvor od content*/
        /* grid-template-rows: 30px 45px calc(100vh - 95px);  */
        grid-template-rows: auto 1fr;
        height: 100%;
    }

    .header {
        grid-row: 1/2;

        display: flex;
        flex-wrap: wrap;
        align-items: center;
        /* background: #ccc; */
        padding: 10px;

        gap: 20px;
    }

    .header div {
        margin-right: 20px;
    }

    .content {
        padding: 0px 10px 10px 10px;
        grid-row: 2/-1;

        overflow: auto;
    }

    .user div {
        margin-bottom: 10px;
    }

    .form {
        display: flex;
        flex-direction: column;
    }

    .form input {
        margin-bottom: 10px;
    }
</style>
